export default [
  // Info Area Settings
  {
    path: "/info/test",
    name: "TestNotify",
    component: () => import("@/views/info/testNotify.vue"),
    meta: {
      pageTitle: "Notify",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Notify",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/bank",
    name: "bank",
    component: () => import("@/views/info/bank/index.vue"),
    meta: {
      pageTitle: "Bank",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Bank",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/bank/edit/id=:id",
    name: "EditBank",
    component: () => import("@/views/info/bank/edit.vue"),
    meta: {
      pageTitle: "EditBank",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "EditBank",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/swiftbic",
    name: "swiftbic",
    component: () => import("@/views/info/swiftbic/index.vue"),
    meta: {
      pageTitle: "SwiftBIC",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "SwiftBIC",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/swiftbic/edit/id=:id",
    name: "EditSwiftBIC",
    component: () => import("@/views/info/swiftbic/edit.vue"),
    meta: {
      pageTitle: "SwiftBIC",
      navActiveLink: "swiftbic",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "SwiftBIC",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/announcement",
    name: "announcement",
    component: () => import("@/views/info/announcement/index.vue"),
    meta: {
      pageTitle: "Announcement",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Announcement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/announcement/edit/id=:id",
    name: "EditAnnouncement",
    component: () => import("@/views/info/announcement/edit.vue"),
    meta: {
      pageTitle: "Announcement",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Announcement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/contractor",
    name: "contractor",
    component: () => import("@/views/info/contractor/index.vue"),
    meta: {
      pageTitle: "Contractor",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Contractor",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/contractor/edit/id=:id",
    name: "EditContractor",
    component: () => import("@/views/info/contractor/edit.vue"),
    meta: {
      pageTitle: "EditContractor",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "EditContractor",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/currency",
    name: "currency",
    component: () => import("@/views/info/currency/index.vue"),
    meta: {
      pageTitle: "Currency",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Currency",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/currency/edit/id=:id",
    name: "EditCurrency",
    component: () => import("@/views/info/currency/edit.vue"),
    meta: {
      pageTitle: "EditCurrency",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "EditCurrency",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/country",
    name: "country",
    component: () => import("@/views/info/country/index.vue"),
    meta: {
      pageTitle: "Country",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Country",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/country/edit/id=:id",
    name: "EditCountry",
    component: () => import("@/views/info/country/edit.vue"),
    meta: {
      pageTitle: "EditCountry",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "EditCountry",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/oked",
    name: "oked",
    component: () => import("@/views/info/oked/index.vue"),
    meta: {
      pageTitle: "Oked",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Oked",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/oked/edit/id=:id",
    name: "EditOked",
    component: () => import("@/views/info/oked/edit.vue"),
    meta: {
      pageTitle: "EditOked",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "EditOked",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/department",
    name: "department",
    component: () => import("@/views/info/department/index.vue"),
    meta: {
      pageTitle: "Department",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Department",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/department/edit/id=:id",
    name: "EditDepartment",
    component: () => import("@/views/info/department/edit.vue"),
    meta: {
      pageTitle: "EditDepartment",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "EditDepartment",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/district",
    name: "district",
    component: () => import("@/views/info/district/index.vue"),
    meta: {
      pageTitle: "District",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "District",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/district/edit/id=:id",
    name: "EditDistrict",
    component: () => import("@/views/info/district/edit.vue"),
    meta: {
      pageTitle: "EditDistrict",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "EditDistrict",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/branch",
    name: "branch",
    component: () => import("@/views/info/branch/index.vue"),
    meta: {
      pageTitle: "Branch",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Branch",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/branch/edit/id=:id",
    name: "EditBranch",
    component: () => import("@/views/info/branch/edit.vue"),
    meta: {
      pageTitle: "EditBranch",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "EditBranch",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/position",
    name: "position",
    component: () => import("@/views/info/position/index.vue"),
    meta: {
      pageTitle: "Position",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Position",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/position/edit/id=:id",
    name: "EditPosition",
    component: () => import("@/views/info/position/edit.vue"),
    meta: {
      pageTitle: "EditPosition",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "EditPosition",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/banktype",
    name: "banktype",
    component: () => import("@/views/info/banktype/index.vue"),
    meta: {
      pageTitle: "BankType",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "BankType",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/banktype/edit/id=:id",
    name: "EditBankType",
    component: () => import("@/views/info/banktype/edit.vue"),
    meta: {
      pageTitle: "EditBankType",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "EditBankType",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/positionclass",
    name: "positionclass",
    component: () => import("@/views/info/positionclass/index.vue"),
    meta: {
      pageTitle: "PositionClass",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "PositionClass",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/positionclass/edit/id=:id",
    name: "EditPositionClass",
    component: () => import("@/views/info/positionclass/edit.vue"),
    meta: {
      pageTitle: "EditPositionClass",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "EditPositionClass",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/cashbox",
    name: "cashbox",
    component: () => import("@/views/info/cashbox/index.vue"),
    meta: {
      pageTitle: "Cashbox",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Cashbox",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/cashbox/edit/id=:id",
    name: "EditCashbox",
    component: () => import("@/views/info/cashbox/edit.vue"),
    meta: {
      pageTitle: "EditCashbox",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "EditCashbox",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/region",
    name: "region",
    component: () => import("@/views/info/region/index.vue"),
    meta: {
      pageTitle: "Region",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Region",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/region/edit/id=:id",
    name: "EditRegion",
    component: () => import("@/views/info/region/edit.vue"),
    meta: {
      pageTitle: "EditRegion",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "EditRegion",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/accountsplan",
    name: "accountsplan",
    component: () => import("@/views/info/accountsplan/index.vue"),
    meta: {
      pageTitle: "AccountsPlan",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "AccountsPlan",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/accountsplan/edit/id=:id",
    name: "EditAccountsPlan",
    component: () => import("@/views/info/accountsplan/edit.vue"),
    meta: {
      pageTitle: "EditAccountsPlan",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "EditAccountsPlan",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/cashretailsettlementaccountconfig",
    name: "cashretailsettlementaccountconfig",
    component: () =>
      import("@/views/info/cashretailsettlementaccountconfig/index.vue"),
    meta: {
      pageTitle: "CashRetailSettlementAccountConfig",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "CashRetailSettlementAccountConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/cashretailsettlementaccountconfig/edit/id=:id",
    name: "EditCashRetailSettlementAccountConfig",
    component: () =>
      import("@/views/info/cashretailsettlementaccountconfig/edit.vue"),
    meta: {
      pageTitle: "CashRetailSettlementAccountConfig",
      navActiveLink: "cashretailsettlementaccountconfig",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "CashRetailSettlementAccountConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/clientoperationsettlementaccountconfig",
    name: "clientoperationsettlementaccountconfig",
    component: () =>
      import("@/views/info/clientoperationsettlementaccountconfig/index.vue"),
    meta: {
      pageTitle: "ClientOperationSettlementAccountConfig",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "ClientOperationSettlementAccountConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/clientoperationsettlementaccountconfig/edit/id=:id",
    name: "EditClientOperationSettlementAccountConfig",
    component: () =>
      import("@/views/info/clientoperationsettlementaccountconfig/edit.vue"),
    meta: {
      pageTitle: "ClientOperationSettlementAccountConfig",
      navActiveLink: "clientoperationsettlementaccountconfig",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "ClientOperationSettlementAccountConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/republiccashretailallowtransactionconfig",
    name: "republiccashretailallowtransactionconfig",
    component: () =>
      import("@/views/info/republiccashretailallowtransactionconfig/index.vue"),
    meta: {
      pageTitle: "RepublicCashRetailAllowTransactionConfig",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "RepublicCashRetailAllowTransactionConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/republiccashretailallowtransactionconfig/edit/id=:id",
    name: "EditRepublicCashRetailAllowTransactionConfig",
    component: () =>
      import("@/views/info/republiccashretailallowtransactionconfig/edit.vue"),
    meta: {
      pageTitle: "RepublicCashRetailAllowTransactionConfig",
      navActiveLink: "republiccashretailallowtransactionconfig",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "RepublicCashRetailAllowTransactionConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/republiccashretailallowtransactionconfig/view/id=:id",
    name: "ViewRepublicCashRetailAllowTransactionConfig",
    component: () =>
      import("@/views/info/republiccashretailallowtransactionconfig/view.vue"),
    meta: {
      pageTitle: "RepublicCashRetailAllowTransactionConfig",
      navActiveLink: "republiccashretailallowtransactionconfig",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "RepublicCashRetailAllowTransactionConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/cashretailsettlementaccountsetting",
    name: "cashretailsettlementaccountsetting",
    component: () =>
      import("@/views/info/cashretailsettlementaccountsetting/index.vue"),
    meta: {
      pageTitle: "Cashretailsettlementaccountsetting",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Cashretailsettlementaccountsetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/cashretailsettlementaccountsetting/edit/id=:id",
    name: "EditCashretailsettlementaccountsetting",
    component: () =>
      import("@/views/info/cashretailsettlementaccountsetting/edit.vue"),
    meta: {
      pageTitle: "Cashretailsettlementaccountsetting",
      navActiveLink: "cashretailsettlementaccountsetting",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Cashretailsettlementaccountsetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/cashretailsettlementaccountsetting/view/id=:id",
    name: "ViewCashretailsettlementaccountsetting",
    component: () =>
      import("@/views/info/cashretailsettlementaccountsetting/view.vue"),
    meta: {
      pageTitle: "Cashretailsettlementaccountsetting",
      navActiveLink: "cashretailsettlementaccountsetting",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Cashretailsettlementaccountsetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/settlementaccount",
    name: "settlementaccount",
    component: () => import("@/views/info/settlementaccount/index.vue"),
    meta: {
      pageTitle: "SettlementAccount",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "SettlementAccount",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/settlementaccount/edit/id=:id",
    name: "EditSettlementAccount",
    component: () => import("@/views/info/settlementaccount/edit.vue"),
    meta: {
      pageTitle: "EditSettlementAccount",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "EditSettlementAccount",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/citizenship",
    name: "citizenship",
    component: () => import("@/views/info/citizenship/index.vue"),
    meta: {
      pageTitle: "Citizenship",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Citizenship",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/citizenship/edit/id=:id",
    name: "EditCitizenship",
    component: () => import("@/views/info/citizenship/edit.vue"),
    meta: {
      pageTitle: "EditCitizenship",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "EditCitizenship",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/nationality",
    name: "nationality",
    component: () => import("@/views/info/nationality/index.vue"),
    meta: {
      pageTitle: "Nationality",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "nationality",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/nationality/edit/id=:id",
    name: "EditNationality",
    component: () => import("@/views/info/nationality/edit.vue"),
    meta: {
      pageTitle: "EditNationality",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "EditNationality",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/unitofmeasure",
    name: "unitofmeasure",
    component: () => import("@/views/info/unitofmeasure/index.vue"),
    meta: {
      pageTitle: "Unitofmeasure",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "unitofmeasure",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/unitofmeasure/edit/id=:id",
    name: "EditUnitofmeasure",
    component: () => import("@/views/info/unitofmeasure/edit.vue"),
    meta: {
      pageTitle: "EditUnitofmeasure",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "EditUnitofmeasure",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/paymentsymbol",
    name: "paymentsymbol",
    component: () => import("@/views/info/paymentsymbol/index.vue"),
    meta: {
      pageTitle: "PaymentSymbol",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "paymentsymbol",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/paymentsymbol/edit/id=:id",
    name: "EditPaymentSymbol",
    component: () => import("@/views/info/paymentsymbol/edit.vue"),
    meta: {
      pageTitle: "EditPaymentSymbol",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "EditPaymentSymbol",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/paymentsymbolpurpose",
    name: "paymentsymbolpurpose",
    component: () => import("@/views/info/paymentsymbolpurpose/index.vue"),
    meta: {
      pageTitle: "PaymentSymbolPurpose",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "PaymentSymbolPurpose",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/paymentsymbolpurpose/edit/id=:id",
    name: "EditPaymentSymbolPurpose",
    component: () => import("@/views/info/paymentsymbolpurpose/edit.vue"),
    meta: {
      pageTitle: "PaymentSymbolPurpose",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "PaymentSymbolPurpose",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/allowtransaction",
    name: "allowtransaction",
    component: () => import("@/views/info/allowtransaction/index.vue"),
    meta: {
      pageTitle: "AllowTransaction",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "allowtransaction",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/allowtransaction/edit/id=:id",
    name: "EditAllowTransaction",
    component: () => import("@/views/info/allowtransaction/edit.vue"),
    meta: {
      pageTitle: "EditAllowTransaction",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "EditAllowTransaction",
          active: true,
        },
      ],
    },
  },

  {
    path: "/info/strictreportingform",
    name: "strictreportingform",
    component: () => import("@/views/info/strictreportingform/index.vue"),
    meta: {
      pageTitle: "StrictReportingForm",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "strictreportingform",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/strictreportingform/edit/id=:id",
    name: "EditStrictReportingForm",
    component: () => import("@/views/info/strictreportingform/edit.vue"),
    meta: {
      pageTitle: "EditStrictReportingForm",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "EditStrictReportingForm",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/bankdate",
    name: "bankdate",
    component: () => import("@/views/info/bankdate/index.vue"),
    meta: {
      pageTitle: "BankDate",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "BankDate",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/bankdate/edit/id=:id",
    name: "EditBankDate",
    component: () => import("@/views/info/bankdate/edit.vue"),
    meta: {
      pageTitle: "EditBankDate",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "EditBankDate",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/collector",
    name: "collector",
    component: () => import("@/views/info/collector/index.vue"),
    meta: {
      pageTitle: "Collector",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Collector",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/collector/edit/id=:id",
    name: "EditCollector",
    component: () => import("@/views/info/collector/edit.vue"),
    meta: {
      pageTitle: "EditCollector",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "EditCollector",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/collectionbag",
    name: "collectionbag",
    component: () => import("@/views/info/collectionbag/index.vue"),
    meta: {
      pageTitle: "CollectionBag",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "CollectionBag",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/collectionbag/edit/id=:id",
    name: "EditCollectionBag",
    component: () => import("@/views/info/collectionbag/edit.vue"),
    meta: {
      pageTitle: "EditCollectionBag",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "EditCollectionBag",
          active: true,
        },
      ],
    },
  },

  {
    path: "/info/paymenttype",
    name: "paymenttype",
    component: () => import("@/views/info/paymenttype/index.vue"),
    meta: {
      pageTitle: "PaymentType",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "PaymentType",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/paymenttype/edit/id=:id",
    name: "EditPaymentType",
    component: () => import("@/views/info/paymenttype/edit.vue"),
    meta: {
      pageTitle: "EditPaymentType",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "EditPaymentType",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/currencyrate",
    name: "currencyrate",
    component: () => import("@/views/info/currencyrate/index.vue"),
    meta: {
      pageTitle: "CurrencyRate",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "CurrencyRate",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/currencyrate/edit/id=:id",
    name: "EditCurrencyRate",
    component: () => import("@/views/info/currencyrate/edit.vue"),
    meta: {
      pageTitle: "EditCurrencyRate",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "EditCurrencyRate",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/currencyrate/view/id=:id",
    name: "ViewCurrencyRate",
    component: () => import("@/views/info/currencyrate/view.vue"),
    meta: {
      pageTitle: "CurrencyRate",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "CurrencyRate",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/clientcontract",
    name: "clientcontract",
    component: () => import("@/views/info/clientcontract/index.vue"),
    meta: {
      pageTitle: "ClientContract",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "ClientContract",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/clientcontract/edit/id=:id",
    name: "EditClientContract",
    component: () => import("@/views/info/clientcontract/edit.vue"),
    meta: {
      pageTitle: "EditClientContract",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "EditClientContract",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/clientpaymenttype",
    name: "clientpaymenttype",
    component: () => import("@/views/info/clientpaymenttype/index.vue"),
    meta: {
      pageTitle: "ClientPaymentType",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "ClientPaymentType",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/clientpaymenttype/edit/id=:id",
    name: "EditClientPaymentType",
    component: () => import("@/views/info/clientpaymenttype/edit.vue"),
    meta: {
      pageTitle: "EditClientPaymentType",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "EditClientPaymentType",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/virtualsettlementaccount",
    name: "virtualsettlementaccount",
    component: () => import("@/views/info/virtualsettlementaccount/index.vue"),
    meta: {
      pageTitle: "VirtualSettlementAccount",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "VirtualSettlementAccount",
          active: true,
        },
      ],
    },
  },

  {
    path: "/info/virtualsettlementaccount/view",
    name: "ViewVirtualSettlementAccount",
    component: () => import("@/views/info/virtualsettlementaccount/view.vue"),
    meta: {
      pageTitle: "ViewVirtualSettlementAccount",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "ViewVirtualSettlementAccount",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/virtualsettlementaccount/edit/id=:id",
    name: "EditVirtualSettlementAccount",
    component: () => import("@/views/info/virtualsettlementaccount/edit.vue"),
    meta: {
      pageTitle: "EditVirtualSettlementAccount",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "ViewVirtualSettlementAccount",
          to: "/info/virtualsettlementaccount/view",
        },
        {
          text: "EditVirtualSettlementAccount",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/bankcategory",
    name: "bankcategory",
    component: () => import("@/views/info/bankcategory/index.vue"),
    meta: {
      pageTitle: "BankCategory",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "BankCategory",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/bankcategory/edit/id=:id",
    name: "EditBankCategory",
    component: () => import("@/views/info/bankcategory/edit.vue"),
    meta: {
      pageTitle: "BankCategory",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "BankCategory",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/documentcontroltype",
    name: "documentcontroltype",
    component: () => import("@/views/info/documentcontroltype/index.vue"),
    meta: {
      pageTitle: "DocumentControlType",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "DocumentControlType",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/documentcontroltype/edit/id=:id",
    name: "EditDocumentControlType",
    component: () => import("@/views/info/documentcontroltype/edit.vue"),
    meta: {
      pageTitle: "DocumentControlType",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "DocumentControlType",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/documentcontrol",
    name: "documentcontrol",
    component: () => import("@/views/info/documentcontrol/index.vue"),
    meta: {
      pageTitle: "DocumentControl",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "DocumentControl",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/documentcontrol/edit/id=:id",
    name: "EditDocumentControl",
    component: () => import("@/views/info/documentcontrol/edit.vue"),
    meta: {
      pageTitle: "DocumentControl",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "DocumentControl",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/changemoneyservicetype",
    name: "changemoneyservicetype",
    component: () => import("@/views/info/changemoneyservicetype/index.vue"),
    meta: {
      pageTitle: "ChangeMoneyServiceType",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "ChangeMoneyServiceType",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/changemoneyservicetype/edit/id=:id",
    name: "EditChangeMoneyServiceType",
    component: () => import("@/views/info/changemoneyservicetype/edit.vue"),
    meta: {
      pageTitle: "ChangeMoneyServiceType",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "ChangeMoneyServiceType",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/changemoneyserviceallowtransactiontable",
    name: "changemoneyserviceallowtransactiontable",
    component: () =>
      import("@/views/info/changemoneyserviceallowtransactiontable/index.vue"),
    meta: {
      pageTitle: "ChangeMoneyServiceAllowTransactionTable",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "ChangeMoneyServiceAllowTransactionTable",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/changemoneyserviceallowtransactiontable/edit/id=:id",
    name: "EditChangeMoneyServiceAllowTransactionTable",
    component: () =>
      import("@/views/info/changemoneyserviceallowtransactiontable/edit.vue"),
    meta: {
      pageTitle: "ChangeMoneyServiceAllowTransactionTable",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "ChangeMoneyServiceAllowTransactionTable",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/transfersystemtype",
    name: "transfersystemtype",
    component: () => import("@/views/info/transfersystemtype/index.vue"),
    meta: {
      pageTitle: "TransferSystemType",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "TransferSystemType",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/transfersystemtype/edit/id=:id",
    name: "EditTransferSystemType",
    component: () => import("@/views/info/transfersystemtype/edit.vue"),
    meta: {
      pageTitle: "TransferSystemType",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "TransferSystemType",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/transfercomissionfee",
    name: "transfercomissionfee",
    component: () => import("@/views/info/transfercomissionfee/index.vue"),
    meta: {
      pageTitle: "TransferComissionFee",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "TransferComissionFee",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/transfercomissionfee/edit/id=:id",
    name: "EditTransferComissionFee",
    component: () => import("@/views/info/transfercomissionfee/edit.vue"),
    meta: {
      pageTitle: "TransferComissionFee",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "TransferComissionFee",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/currencyexchangelimit",
    name: "currencyexchangelimit",
    component: () => import("@/views/info/currencyexchangelimit/index.vue"),
    meta: {
      pageTitle: "CurrencyExchangeLimit",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "CurrencyExchangeLimit",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/currencyexchangelimit/edit/id=:id",
    name: "EditCurrencyExchangeLimit",
    component: () => import("@/views/info/currencyexchangelimit/edit.vue"),
    meta: {
      pageTitle: "CurrencyExchangeLimit",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "CurrencyExchangeLimit",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/customer",
    name: "customer",
    component: () => import("@/views/info/customer/index.vue"),
    meta: {
      pageTitle: "Customer",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Customer",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/customer/edit/id=:id",
    name: "EditCustomer",
    component: () => import("@/views/info/customer/edit.vue"),
    meta: {
      pageTitle: "Customer",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Customer",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/currencyexchangeallowtransactionconfigtable",
    name: "currencyexchangeallowtransactionconfigtable",
    component: () =>
      import("@/views/info/currencyexchangeallowtransactionconfigtable/index.vue"),
    meta: {
      pageTitle: "CurrencyExchangeAllowTransactionConfigTable",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "CurrencyExchangeAllowTransactionConfigTable",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/currencyexchangeallowtransactionconfigtable/edit/id=:id",
    name: "EditCurrencyExchangeAllowTransactionConfigTable",
    component: () =>
      import("@/views/info/currencyexchangeallowtransactionconfigtable/edit.vue"),
    meta: {
      pageTitle: "CurrencyExchangeAllowTransactionConfigTable",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "CurrencyExchangeAllowTransactionConfigTable",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/currencyexchangeconfig",
    name: "currencyexchangeconfig",
    component: () => import("@/views/info/currencyexchangeconfig/index.vue"),
    meta: {
      pageTitle: "CurrencyExchangeConfig",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "CurrencyExchangeConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/currencyexchangeconfig/edit/id=:id",
    name: "EditCurrencyExchangeConfig",
    component: () => import("@/views/info/currencyexchangeconfig/edit.vue"),
    meta: {
      pageTitle: "CurrencyExchangeConfig",
      navActiveLink: "currencyexchangeconfig",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "CurrencyExchangeConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/currencyexchangeidentificator",
    name: "currencyexchangeidentificator",
    component: () =>
      import("@/views/info/currencyexchangeidentificator/index.vue"),
    meta: {
      pageTitle: "CurrencyExchangeIdentificator",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "CurrencyExchangeIdentificator",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/currencyexchangeidentificator/edit/id=:id",
    name: "EditCurrencyExchangeIdentificator",
    component: () =>
      import("@/views/info/currencyexchangeidentificator/edit.vue"),
    meta: {
      pageTitle: "CurrencyExchangeIdentificator",
      navActiveLink: "currencyexchangeidentificator",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "CurrencyExchangeIdentificator",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/checktemplate",
    name: "checktemplate",
    component: () => import("@/views/info/checktemplate/index.vue"),
    meta: {
      pageTitle: "CheckTemplate",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "CheckTemplate",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/checktemplate/edit/id=:id",
    name: "EditCheckTemplate",
    component: () => import("@/views/info/checktemplate/edit.vue"),
    meta: {
      pageTitle: "CheckTemplate",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "CheckTemplate",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/clientpaymentconfig",
    name: "clientpaymentconfig",
    component: () => import("@/views/info/clientpaymentconfig/index.vue"),
    meta: {
      pageTitle: "ClientPaymentConfig",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "ClientPaymentConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/clientpaymentconfig/edit/id=:id",
    name: "EditClientPaymentConfig",
    component: () => import("@/views/info/clientpaymentconfig/edit.vue"),
    meta: {
      pageTitle: "ClientPaymentConfig",
      navActiveLink: "clientpaymentconfig",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "ClientPaymentConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/clientpaymentallowtransactionconfigtable",
    name: "clientpaymentallowtransactionconfigtable",
    component: () =>
      import("@/views/info/clientpaymentallowtransactionconfigtable/index.vue"),
    meta: {
      pageTitle: "ClientPaymentAllowTransactionConfigTable",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "ClientPaymentAllowTransactionConfigTable",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/clientpaymentallowtransactionconfigtable/edit/id=:id",
    name: "EditClientPaymentAllowTransactionConfigTable",
    component: () =>
      import("@/views/info/clientpaymentallowtransactionconfigtable/edit.vue"),
    meta: {
      pageTitle: "ClientPaymentAllowTransactionConfigTable",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "ClientPaymentAllowTransactionConfigTable",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/atmdevice",
    name: "atmdevice",
    component: () => import("@/views/info/atmdevice/index.vue"),
    meta: {
      pageTitle: "Atm",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Atm",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/atmdevice/edit/id=:id",
    name: "EditAtmDevice",
    component: () => import("@/views/info/atmdevice/edit.vue"),
    meta: {
      pageTitle: "Atm",
      navActiveLink: "atmdevice",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Atm",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/atmpaymenttype",
    name: "atmpaymenttype",
    component: () => import("@/views/info/atmpaymenttype/index.vue"),
    meta: {
      pageTitle: "AtmPaymentType",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "AtmPaymentType",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/atmpaymenttype/edit/id=:id",
    name: "EditAtmPaymentType",
    component: () => import("@/views/info/atmpaymenttype/edit.vue"),
    meta: {
      pageTitle: "AtmPaymentType",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "AtmPaymentType",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/cassette",
    name: "cassette",
    component: () => import("@/views/info/cassette/index.vue"),
    meta: {
      pageTitle: "Cassette",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Cassette",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/cassette/edit/id=:id",
    name: "EditCassette",
    component: () => import("@/views/info/cassette/edit.vue"),
    meta: {
      pageTitle: "Cassette",
      navActiveLink: "cassette",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "Cassette",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/clientPaymentTypeGroup",
    name: "clientPaymentTypeGroup",
    component: () => import("@/views/info/clientPaymentTypeGroup/index.vue"),
    meta: {
      pageTitle: "ClientPaymentTypeGroup",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "ClientPaymentTypeGroup",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/stateawardtype",
    name: "stateawardtype",
    component: () => import("@/views/info/stateAwardType/index.vue"),
    meta: {
      pageTitle: "StateAwardType",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "StateAwardType",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/stateawardtype/edit/id=:id",
    name: "EditStateAwardType",
    component: () => import("@/views/info/stateAwardType/edit.vue"),
    meta: {
      pageTitle: "StateAwardType",
      navActiveLink: "stateawardtype",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "StateAwardType",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/governmentdecree",
    name: "governmentdecree",
    component: () => import("@/views/info/governmentDecree/index.vue"),
    meta: {
      pageTitle: "GovernmentDecree",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "GovernmentDecree",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/governmentdecree/edit/id=:id",
    name: "EditGovernmentDecree",
    component: () => import("@/views/info/governmentDecree/edit.vue"),
    meta: {
      pageTitle: "GovernmentDecree",
      navActiveLink: "governmentdecree",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "GovernmentDecree",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/ihmapaymenttype",
    name: "ihmapaymenttype",
    component: () => import("@/views/info/ihmapaymenttype/index.vue"),
    meta: {
      pageTitle: "IhmaPaymentType",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "IhmaPaymentType",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/ihmapaymenttype/edit/id=:id",
    name: "EditIhmaPaymentType",
    component: () => import("@/views/info/ihmapaymenttype/edit.vue"),
    meta: {
      pageTitle: "IhmaPaymentType",
      navActiveLink: "ihmapaymenttype",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "IhmaPaymentType",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/ihmacommunalsetting",
    name: "ihmacommunalsetting",
    component: () => import("@/views/info/ihmacommunalsetting/index.vue"),
    meta: {
      pageTitle: "IhmaCommunalSetting",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "IhmaCommunalSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/ihmacommunalsetting/edit/id=:id",
    name: "EditIhmaCommunalSetting",
    component: () => import("@/views/info/ihmacommunalsetting/edit.vue"),
    meta: {
      pageTitle: "IhmaCommunalSetting",
      navActiveLink: "ihmacommunalsetting",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "IhmaCommunalSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/internalvaluablemovementtype",
    name: "internalvaluablemovementtype",
    component: () =>
      import("@/views/info/internalValuableMovementType/index.vue"),
    meta: {
      pageTitle: "InternalValuableMovementType",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "InternalValuableMovementType",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/utilspayment",
    name: "utilspayment",
    component: () => import("@/views/info/utilsPayment/index.vue"),
    meta: {
      pageTitle: "UtilsPayment",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "UtilsPayment",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/utilspaymentinfo",
    name: "utilspaymentinfo",
    component: () => import("@/views/info/utilsPaymentInfo/index.vue"),
    meta: {
      pageTitle: "UtilsPaymentInfo",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "UtilsPaymentInfo",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/autopaymenttype",
    name: "autopaymenttype",
    component: () => import("@/views/info/autopaymenttype/index.vue"),
    meta: {
      pageTitle: "AutoPaymentType",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "AutoPaymentType",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/autopaymenttype/edit/id=:id",
    name: "EditAutoPaymentType",
    component: () => import("@/views/info/autopaymenttype/edit.vue"),
    meta: {
      pageTitle: "AutoPaymentType",
      navActiveLink: "autopaymenttype",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "AutoPaymentType",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/currencyconversionpurposetype",
    name: "currencyconversionpurposetype",
    component: () =>
      import("@/views/info/currencyconversionpurposetype/index.vue"),
    meta: {
      pageTitle: "CurrencyConversionPurposeType",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "CurrencyConversionPurposeType",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/currencyconversionpurposetype/edit/id=:id",
    name: "EditCurrencyConversionPurposeType",
    component: () =>
      import("@/views/info/currencyconversionpurposetype/edit.vue"),
    meta: {
      pageTitle: "CurrencyConversionPurposeType",
      navActiveLink: "currencyconversionpurposetype",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "CurrencyConversionPurposeType",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/withdrawalpurposetype",
    name: "withdrawalpurposetype",
    component: () => import("@/views/info/withdrawalpurposetype/index.vue"),
    meta: {
      pageTitle: "WithdrawalPurposeType",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "WithdrawalPurposeType",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/withdrawalpurposetype/edit/id=:id",
    name: "EditWithdrawalPurposeType",
    component: () => import("@/views/info/withdrawalpurposetype/edit.vue"),
    meta: {
      pageTitle: "WithdrawalPurposeType",
      navActiveLink: "withdrawalpurposetype",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "WithdrawalPurposeType",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/clientcurrencyrate",
    name: "clientcurrencyrate",
    component: () => import("@/views/info/clientcurrencyrate/index.vue"),
    meta: {
      pageTitle: "ClientCurrencyRate",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "ClientCurrencyRate",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/clientcurrencyrate/edit/id=:id",
    name: "EditClientCurrencyRate",
    component: () => import("@/views/info/clientcurrencyrate/edit.vue"),
    meta: {
      pageTitle: "ClientCurrencyRate",
      navActiveLink: "clientcurrencyrate",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "ClientCurrencyRate",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/currencyconversionsetting",
    name: "currencyconversionsetting",
    component: () => import("@/views/info/currencyconversionsetting/index.vue"),
    meta: {
      pageTitle: "CurrencyConversionSetting",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "CurrencyConversionSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/currencyconversionsetting/edit/:id",
    name: "EditCurrencyConversionSetting",
    component: () => import("@/views/info/currencyconversionsetting/edit.vue"),
    meta: {
      pageTitle: "CurrencyConversionSetting",
      navActiveLink: "currencyconversionsetting",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "CurrencyConversionSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/canceltransactionsetting",
    name: "canceltransactionsetting",
    component: () => import("@/views/info/canceltransactionsetting/index.vue"),
    meta: {
      pageTitle: "CancelTransactionSetting",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "CancelTransactionSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/info/canceltransactionsetting/edit/:id",
    name: "EditCancelTransactionSetting",
    component: () => import("@/views/info/canceltransactionsetting/edit.vue"),
    meta: {
      pageTitle: "CancelTransactionSetting",
      navActiveLink: "canceltransactionsetting",
      breadcrumb: [
        {
          text: "Info",
        },
        {
          text: "CancelTransactionSetting",
          active: true,
        },
      ],
    },
  },
]
